// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AudioRecorderController from "./audio_recorder_controller"
application.register("audio-recorder", AudioRecorderController)

import BulkSelectController from "./bulk_select_controller"
application.register("bulk-select", BulkSelectController)

import BulkUploadController from "./bulk_upload_controller"
application.register("bulk-upload", BulkUploadController)

import CameraCaptureController from "./camera_capture_controller"
application.register("camera-capture", CameraCaptureController)

import ClassificationAttributeFormController from "./classification_attribute_form_controller"
application.register("classification-attribute-form", ClassificationAttributeFormController)

import ClassificationSpaController from "./classification_spa_controller"
application.register("classification-spa", ClassificationSpaController)

import ClassificationSuggestController from "./classification_suggest_controller"
application.register("classification-suggest", ClassificationSuggestController)

import ClassificationVisualElementController from "./classification_visual_element_controller"
application.register("classification-visual-element", ClassificationVisualElementController)


import ConfidenceSliderController from "./confidence_slider_controller"
application.register("confidence-slider", ConfidenceSliderController)

import ConnectionStatusController from "./connection_status_controller"
application.register("connection-status", ConnectionStatusController)

import ChoicesController from "./choices_controller"
application.register("choices", ChoicesController)

import DebouncedFormController from "./debounced_form_controller"
application.register("debounced-form", DebouncedFormController)

import DemoUploadController from "./demo_upload_controller"
application.register("demo-upload", DemoUploadController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FindingsToggleController from "./findings_toggle_controller"
application.register("findings-toggle", FindingsToggleController)

import GeneratedAttributesController from "./generated_attributes_controller"
application.register("generated-attributes", GeneratedAttributesController)

import GroupPhotosToggleController from "./group_photos_toggle_controller"
application.register("group-photos-toggle", GroupPhotosToggleController)

import LazyInvoicesController from "./lazy_invoices_controller"
application.register("lazy-invoices", LazyInvoicesController)

import LinkToTurboModalController from "./link_to_turbo_modal_controller"
application.register("link-to-turbo-modal", LinkToTurboModalController)

import LocalFormSubmissionController from "./local_form_submission_controller"
application.register("local-form-submission", LocalFormSubmissionController)

import MainVisualElementController from "./main_visual_element_controller"
application.register("main-visual-element", MainVisualElementController)

import NoticesController from "./notices_controller"
application.register("notices", NoticesController)

import RotationPreviewController from "./rotation_preview_controller"
application.register("rotation-preview", RotationPreviewController)

import PhotoUploadController from "./photo_upload_controller"
application.register("photo-upload", PhotoUploadController)

import ProjectFormController from "./project_form_controller"
application.register("project-form", ProjectFormController)

import ProgressBarController from "./progress_bar_controller"
application.register("progress-bar", ProgressBarController)

import ProjectSpecificationFormController from "./project_specification_form_controller"
application.register("project-specification-form", ProjectSpecificationFormController)

import ServiceWorkerController from "./service_worker_controller"
application.register("service-worker", ServiceWorkerController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SimilaritySliderController from "./similarity_slider_controller"
application.register("similarity-slider", SimilaritySliderController)

import StripePaymentMethodController from "./stripe_payment_method_controller"
application.register("stripe-payment-method", StripePaymentMethodController)

import SubscriptionPlanSelectorController from "./subscription_plan_selector_controller"
application.register("subscription-plan-selector", SubscriptionPlanSelectorController)

import SuggestController from "./suggest_controller"
application.register("suggest", SuggestController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import ToggleableBarController from "./toggleable_bar_controller"
application.register("toggleable-bar", ToggleableBarController)

import UsageReportFilterController from "./usage_report_filter_controller"
application.register("usage-report-filter", UsageReportFilterController)